import { render, staticRenderFns } from "./EmpTreeSelect.vue?vue&type=template&id=2efc16a6&scoped=true"
import script from "./EmpTreeSelect.vue?vue&type=script&lang=js"
export * from "./EmpTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc16a6",
  null
  
)

export default component.exports